// 封鎖、刪除貼文、留言 確認彈窗
import { useRouter } from 'next/navigation';
import userClient from '@/common/apiClient/userClient';
import newsClient from '@/common/apiClient/newsClient';

const ConfirmModal = ({ t, dispatch, showConfirmModal = {}, setShowConfirmModal }) => {
    const router = useRouter();

    // 類型、暱稱
    const { type, nickname, authorUid, newsId, newsCommentId, location } = showConfirmModal;

    // 關閉彈窗
    const onClose = () => dispatch(setShowConfirmModal(false));

    // 刪除留言
    const onDeleteComment = async () => {
        try {
            const { message } = await newsClient.deleteComment({ newsId, newsCommentId });
            if (message === 'NewsComment deleted successfully') {
                dispatch(setShowConfirmModal('done'));
            }
        } catch (e) {
            console.error(e);
        }
    };

    // 封鎖
    const onBlock = async () => {
        try {
            const { msg } = await userClient.toggleBlockUser({ blockUid: authorUid });
            // 封鎖成功
            if (msg === 'create block') {
                if (location !== 'comment') {
                    onClose();
                    router.push('/');
                } else dispatch(setShowConfirmModal('done'));
            }
        } catch (e) {
            console.error(e);
        }
    };

    // 點擊
    const onClick = () => {
        // 刪除留言
        if (type === 'REMOVE') onDeleteComment();
        if (type === 'BLOCK') onBlock();
    };

    return (
        <div className="modal">
            <div className="bg-white rounded-[22px] w-[400px] max-w-full p-[30px] border-1 border-black1">
                <p className="text-h6 text-jblack">
                    {t(`${type}_TITLE`)?.replace('user', nickname)}
                </p>

                <p
                    className="mt-[22px] mb-[30px] text-btn4 text-black9"
                    dangerouslySetInnerHTML={{
                        __html: t(`${type}_CONTENT`),
                    }}
                />

                <div className="between-center text-btn1 [&>button]:rounded-[400px] [&>button]:px-[31px] [&>button]:py-[14px] [&>button]:trans">
                    {/* 取消 */}
                    <button
                        onClick={onClose}
                        className="bg-black1 text-black9 hover:bg-black hover:text-white dark:hover:!text-[#1e1e1e]"
                    >
                        {t('CANCEL')}
                    </button>

                    {/* 刪除 */}
                    <button onClick={onClick} className="bg-red0 text-[#fff] hover:bg-vPurple">
                        {t(type === 'BLOCK' ? 'BLOCK' : 'DELETE')}
                    </button>
                </div>
            </div>

            <div
                className="close-bg bg-[#1e1e1e] bg-opacity-[.7]"
                onClick={() => dispatch(setShowConfirmModal(false))}
            />
        </div>
    );
};

export default ConfirmModal;
